export default __webpack_public_path__ + "static/media/asset-6.4190d2c1.webp";